import { Query, QueryResult } from "material-table";
import qs from "qs";

import { ApiService } from "services/Api.service";
import { constructQueryParams } from "utils/query/constructQueryParams";
import { Category, CategoryDTO } from "models/prize/category/Category";

export interface CategoryServiceInterface {
  list(query: Query<Category>, params?: any): Promise<QueryResult<Category>>;
  get(category: Category): Promise<Category>;
  create(data: any): Promise<Category>;
  edit(category: Category, values: any): Promise<Category>;
  delete(category: Category): Promise<void>;
  getSupplierCategories(): Promise<any[]>;
}

export class CategoryService implements CategoryServiceInterface {
  private _apiService: ApiService;

  constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  async list(
    query: Query<Category>,
    params?: any
  ): Promise<QueryResult<Category>> {
    const queryParams = {
      ...constructQueryParams<Category>(query),
      ...params
    };

    const rawCategoryTree: CategoryDTO[] = await this._apiService.get(
      "/steve/admin/category",
      {
        searchFields: [],
        ...queryParams
      },
      {
        paramsSerializer: (params: any) => qs.stringify(params)
      }
    );

    const categoryTree = rawCategoryTree.map(dto => Category.create(dto));

    const flatten = (categories: Category[]): Category[] => {
      return categories.reduce(
        (acc, category) => {
          acc.push(category);
          if (category.children.length > 0) {
            acc.push(...flatten(category.children));
          }
          return acc;
        },
        [] as Category[]
      );
    };

    const flatList = flatten(categoryTree);

    return {
      totalCount: flatList.length,
      page: query.page,
      data: flatList
    };
  }

  async get(category: Category): Promise<Category> {
    return await Promise.resolve(category);
  }

  async create(data: any): Promise<Category> {
    return this._apiService.post(`/steve/admin/category`, data);
  }

  async edit(category: Category, data: any): Promise<Category> {
    return await this._apiService.put(
      `/steve/admin/category/${category.id}`,
      data
    );
  }

  async delete(category: Category): Promise<void> {
    return this._apiService.delete(`/steve/admin/category/${category.id}`);
  }

  async getSupplierCategories(): Promise<any[]> {
    const { list } = await this._apiService.get("/steve/supplier-category");
    return list;
  }
}
